import { array, boolean, object, string } from 'yup'
import { PlanSettingsFormValues } from './utils'

export const planSettingsSchema = object({
  planStoreyPolicy: string().oneOf(['ElementStorey', 'UserDefined']).required(),
  storeysForPlans: array().of(string().required()).required(),
  use_global_live_loads: boolean(),
})

export type PlanSettingsSchema = PlanSettingsFormValues
